module.exports = __webpack_public_path__ + "img/sv15.7a69a4da.svg";